import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    name: "",
    categories: [],
    users: [],
    photos: [0,999],
    status: "",
    type: "",
    date_from: null,
    date_to: null
}

export const albumsFilterSlice = createSlice({
    name: 'albumsFilter',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = {
                    ...state,
                    ...initialState
                };
            }
            state = {
                ...state, 
                ...payload.payload
            };
            return state;
        }
    },
})

export const { edit } = albumsFilterSlice.actions

export default albumsFilterSlice.reducer